// extracted by mini-css-extract-plugin
module.exports = {"notFound":"not-found_notFound__chXXH","inner":"not-found_inner__2wcSj","title":"not-found_title__krlRK"};